import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useCartId } from 'lib/core/hooks/useCart'
import { setLockCheckout } from 'lib/core/data/quote/lockCheckout'
import { createSetPurchaseOrder } from './purchaseOrder'
import { createFreePaymentMethod } from './freePaymentMethod'

export const useOfflinePaymentMethod = () => {
  const dispatch = useDispatch()
  const cartId = useCartId()

  const lockCheckout = useCallback(() => {
    if (!cartId) {
      return
    }

    dispatch(setLockCheckout({
      cartId,
      value: true
    }))
  }, [cartId, dispatch])

  const unlockCheckout = useCallback(() => {
    if (!cartId) {
      return
    }

    dispatch(setLockCheckout({
      cartId,
      value: false
    }))
  }, [cartId, dispatch])

  return {
    setPurchaseOrder: createSetPurchaseOrder({ cartId, lockCheckout, unlockCheckout }),
    setFreePaymentMethod: createFreePaymentMethod({ cartId, lockCheckout, unlockCheckout })
  }
}
